import { Modal } from 'antd';
import { MilestoneScale } from './MilestoneScale';
import { encountersToUnlock } from './config';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

function CoundownModal({ open, onCancel, completedEncounters }) {
  const remainingEncounters = encountersToUnlock - completedEncounters;
  const { user } = useAuth();

  const handleCancel = () => {
    analytics.track(`Clicked Lets Go In Pro Trial Countdown Modal`, {
      email: user?.email,
    });
    onCancel?.();
  };

  return (
    <Modal
      open={open}
      width={480}
      onCancel={onCancel}
      footer={
        <div className="flex justify-center">
          <button className="ih-button-primary" onClick={handleCancel}>
            Let&apos;s go
          </button>
        </div>
      }
      centered
    >
      <div className="flex flex-col items-center text-center gap-4 mb-6 px-6">
        <div className="text-lg font-medium">Countdown to pro trial</div>
        <MilestoneScale
          total={encountersToUnlock}
          completed={completedEncounters}
        />
        <div>
          <div className="text-2xl font-semibold">
            {remainingEncounters} more encounters
          </div>
          <div className="text-md">to activate free 30-day pro trial</div>
        </div>
      </div>
    </Modal>
  );
}

export { CoundownModal };
